import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'

import ViewsLoader from '../../../loader/ViewsLoader'
import { RedTitle } from './global/RedTitle'
import { ScheduleByDay } from '../../forms/scheduling/components/ScheduleByDay'

import FirestoreService from '../../../../services/firestoreService'

import {
  IEventFees,
  RegistrationFeesType,
} from '../../../../models/event-fees/event-fees.interface'
import { EventFeesModel } from '../../../../models/event-fees/event-fees.model'
import { IEventScheduleInterface } from '../../../../models/event-scheduling/event-scheduling.interface'
import { EventSchedulingModel } from '../../../../models/event-scheduling/event-scheduling.model'
import ITypes from '../../../../pages/competitor/event-registration-tabs/hooks/useEventRegistrationTabs.types'

import { CONST } from '../../../../const/const'

const EventScheduleTab = () => {
  const { eventId } = useParams<ITypes['IParams']>()

  const [registrationFees, setRegistrationFees] = useState<RegistrationFeesType[] | null>(null)
  const [customScheduling, setCustomScheduling] = useState<
    IEventScheduleInterface['custom'] | null
  >(null)
  const [loading, setLoading] = useState(true)
  const [scheduleBy, setScheduleBy] = useState<'class' | 'rider'>('class')

  const fetchData = async () => {
    let custom: IEventScheduleInterface['custom'] = []
    let eventEntries: IEventFees['registrationFees'] = []

    const eventSchedulingSnaps = await FirestoreService.getItem(
      CONST.DATA.FIRESTORE.LATEST.COLLECTIONS.EVENT_SCHEDULING.NAME,
      eventId
    )

    if (eventSchedulingSnaps.exists()) {
      custom = EventSchedulingModel.fromFirestoreDoc(eventSchedulingSnaps).toObject().custom
    }

    const scheduleByDataPoint = eventSchedulingSnaps?.data()?.scheduleBy ?? 'class'

    setScheduleBy(scheduleByDataPoint)

    const eventEntriesSnaps = await FirestoreService.getItem(
      CONST.DATA.FIRESTORE.LATEST.COLLECTIONS.EVENT_FEES.NAME,
      eventId
    )

    if (eventEntriesSnaps.exists()) {
      eventEntries = EventFeesModel.fromFirestoreDoc(eventEntriesSnaps).toObject().registrationFees
    }

    setRegistrationFees(eventEntries)
    setCustomScheduling(custom)
    setLoading(false)
  }

  useEffect(() => {
    if (eventId) fetchData().then()
  }, [eventId])

  return (
    <>
      <RedTitle text="Schedule" className="mb-1" />

      {loading && (
        <div className="flex justify-center items-center h-[100px]">
          <ViewsLoader
            className="flex items-center w-full justify-center min-h-[30vh] mt-3"
            size="lg"
            color="#F70763"
          />
        </div>
      )}
      <ScheduleByDay
        scheduleBy={scheduleBy}
        registrationFees={registrationFees}
        customScheduling={customScheduling}
      />
    </>
  )
}

export default EventScheduleTab
